/* ============================================================
   ANJUS — Global theme JS (Shopify)
   Ported from the original site.js / chrome.js, with:
     - the custom localStorage cart replaced by Shopify's AJAX cart
     - the mock currency converter replaced by Shopify's native
       localization form (Markets) in the header
     - the design "tweaks" panel removed (design is now fixed)
   Kept intact: the 1440px proportional zoom scaling, scroll parallax,
   header scroll-fade, cookie banner, menu + currency + cart drawer UI.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Phone content-page line breaks ----------
     About/Contact copy uses hard-coded <br> as desktop line breaks (often in
     place of a space). On phones those breaks land awkwardly and can glue words
     together, so convert them to spaces here. */
  function fixContentBreaks() {
    if (!document.body) return;
    if (!window.matchMedia('(max-width:767.98px)').matches) return;
    if (!(document.body.classList.contains('page-about') || document.body.classList.contains('page-contact'))) return;
    document.querySelectorAll('.page-about .rte-block, .page-about section p, .page-contact .rte-block, .page-contact section p').forEach(function (el) {
      el.querySelectorAll('br').forEach(function (br) { br.replaceWith(' '); });
    });
  }
  fixContentBreaks();
  window.addEventListener('resize', fixContentBreaks, { passive: true });

  /* ---------- Proportional viewport scaling ----------
     The desktop site is a fixed 1440px composition scaled to fill the
     window with CSS zoom. Below MOBILE_MAX we DON'T scale — the phone
     gets its own dedicated flow layout (see mobile.css + the .home-mobile
     markup), so we clear the zoom and let the page render at 1:1. This
     boundary must match the @media breakpoint in mobile.css (767.98px). */
  var DESIGN_WIDTH = 1440;
  var MOBILE_MAX = 767.98;
  var scaleQueued = false;
  function applyScale() {
    scaleQueued = false;
    if (!document.body) return;
    var w = document.documentElement.clientWidth;
    // Only pages with a dedicated mobile layout (body.mobile-native, set per
    // template in theme.liquid) drop the zoom on phones. Every other page keeps
    // the proportional 1440 shrink-to-fit fallback until its mobile layout is
    // built — otherwise its desktop-only markup would overflow on a phone.
    if (w <= MOBILE_MAX && document.body.classList.contains('mobile-native')) {
      document.body.style.zoom = '';
    } else {
      document.body.style.zoom = (w / DESIGN_WIDTH).toFixed(5);
    }
  }
  function queueScale() {
    if (scaleQueued) return;
    scaleQueued = true;
    requestAnimationFrame(applyScale);
  }
  applyScale();
  window.addEventListener('resize', queueScale, { passive: true });
  window.addEventListener('orientationchange', queueScale, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyScale);
  window.addEventListener('load', applyScale);

  /* ---------- Menu dropdown ---------- */
  function setupMenu() {
    var toggle = document.getElementById('menu-toggle');
    var menu = document.getElementById('menu-dropdown');
    if (!toggle || !menu) return;
    function open() { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); toggle.setAttribute('aria-expanded', 'true'); toggle.classList.add('is-active'); }
    function close() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false'); toggle.classList.remove('is-active'); }
    toggle.addEventListener('click', function (e) { e.stopPropagation(); menu.classList.contains('is-open') ? close() : open(); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('click', function (e) { if (menu.classList.contains('is-open') && !menu.contains(e.target) && !toggle.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Currency / country selector (Shopify localization) ---------- */
  function setupCurrency() {
    var wrap = document.querySelector('[data-currency]');
    if (!wrap) return;
    var toggle = wrap.querySelector('.cur-toggle');
    var menu = wrap.querySelector('.cur-menu');
    if (!toggle || !menu) return;
    function close() { menu.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', function (e) { e.stopPropagation(); var open = menu.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    menu.querySelectorAll('[data-cur]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = wrap.querySelector('input[name="currency_code"], input[name="country_code"]');
        var form = wrap.querySelector('form');
        if (input && form) { input.value = b.getAttribute('data-cur'); form.submit(); }
      });
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cookie banner (wired to Shopify's Customer Privacy API) ----------
     This on-brand banner records real tracking consent through Shopify's
     consent API, so Accept/Decline genuinely turns tracking (analytics,
     marketing/pixels) on or off — not just a cosmetic click. */
  var COOKIE_KEY = 'anjus.cookies.v1';
  function applyConsent(accepted) {
    function set() {
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent({
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted ? 'enabled' : 'disabled'
          }, function () {});
        }
      } catch (e) {}
    }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) set(); });
    } else { set(); }
  }
  function setupCookies() {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;
    // Only show if the visitor hasn't answered yet. Where Shopify signals a
    // consent decision already exists, respect it and stay hidden.
    var answered = false;
    try { answered = !!localStorage.getItem(COOKIE_KEY); } catch (e) {}
    if (!answered) setTimeout(function () { banner.classList.remove('is-hidden'); }, 1200);
    banner.querySelectorAll('[data-cookie-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var accepted = btn.dataset.cookieAction === 'accepted';
        try { localStorage.setItem(COOKIE_KEY, btn.dataset.cookieAction); } catch (e) {}
        applyConsent(accepted);
        banner.classList.add('is-hidden');
      });
    });
  }

  /* ---------- Policy lightboxes (Delivery / Privacy / Terms) ---------- */
  function setupPolicyModal() {
    var modals = document.querySelectorAll('.policy-modal');
    if (!modals.length) return;
    var lastFocus = null;
    function openModal(modal) { lastFocus = document.activeElement; modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var c = modal.querySelector('.policy-close'); if (c) c.focus(); }
    function closeAll() { modals.forEach(function (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); }); document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-policy-open]');
      if (opener) { e.preventDefault(); var key = opener.getAttribute('data-policy-open') || 'delivery'; var modal = document.querySelector('.policy-modal[data-policy-modal="' + key + '"]'); if (modal) openModal(modal); return; }
      if (e.target.closest('[data-policy-close]')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Header scroll-fade + live chrome ----------
     The hamburger/icons/logo flip dark<->light to stay legible over whatever
     section is behind the faded bar. Point hit-testing is unreliable here (the
     page uses a fixed 1440px `zoom`, and surfaces are painted with images), so
     we scan the flow's wide, solidly-coloured surfaces by geometry instead —
     which the zoom does not distort — and fall back to the page's declared
     chrome for image-only surfaces (e.g. the hero). */
  function setupHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var brand = header.querySelector('.brandmark');
    var ticking = false;
    var pageDark = document.body.getAttribute('data-hero-chrome') === 'dark';
    var lastDark = null;
    var surfaces = [];

    function opaque(str) {
      var m = str && str.match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      var p = m[1].split(',').map(function (s) { return parseFloat(s); });
      if ((p.length > 3 ? p[3] : 1) < 0.6) return null;
      return p;
    }
    function isDark(p) { return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255 < 0.55; }

    // Catalogue wide surfaces that declare a tone — via an opaque background
    // colour or an explicit data-chrome="dark|light". Recomputed on resize.
    function catalogue() {
      surfaces = [];
      var vw = window.innerWidth || document.documentElement.clientWidth || 1440;
      var all = document.body.getElementsByTagName('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (header.contains(el)) continue;
        var cs = getComputedStyle(el);
        // Only in-flow page surfaces — skip floating overlays (cookie banner,
        // cart drawer, modals) which aren't the background behind the header.
        if (cs.position === 'fixed' || cs.position === 'absolute' || cs.position === 'sticky') continue;
        var dc = el.getAttribute && el.getAttribute('data-chrome');
        var col = dc ? null : opaque(cs.backgroundColor);
        if (!dc && !col) continue;
        var r = el.getBoundingClientRect();
        // Must be a real background band — wide and not a thin divider/button.
        if (r.width < vw * 0.5 || r.height < 48) continue;
        surfaces.push({ el: el, dark: dc ? dc === 'dark' : isDark(col) });
      }
    }

    // Tone of the most specific catalogued surface under the header baseline.
    function surfaceTone() {
      var hb = header.getBoundingClientRect().bottom + 6;
      var best = null, bestH = Infinity;
      for (var i = 0; i < surfaces.length; i++) {
        var r = surfaces[i].el.getBoundingClientRect();
        if (r.top <= hb && r.bottom > hb && r.height < bestH) { best = surfaces[i]; bestH = r.height; }
      }
      return best ? best.dark : null; // null → nothing solid there (image hero etc.)
    }

    function apply() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 64);
      if (brand) brand.style.opacity = Math.max(0, 1 - y / 300).toFixed(3);
      var tone = surfaceTone();
      var dark = tone === null ? pageDark : tone;
      if (dark !== lastDark) {
        lastDark = dark;
        header.classList.toggle('chrome-dark', dark);
        header.classList.toggle('chrome-light', !dark);
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { window.requestAnimationFrame(apply); ticking = true; } }

    catalogue();
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { catalogue(); onScroll(); }, { passive: true });
    window.addEventListener('load', function () { catalogue(); apply(); });
  }

  /* ---------- Scroll parallax ---------- */
  function setupHeroParallax() {
    var sels = ['.campaign-hero .stage-bg', '.approach-section'];
    var items = [];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var inline = el.getAttribute('style') || '';
        var m = inline.match(/background-position:\s*([^;]+?)(?:;|$)/);
        var x = 'center', yPct = 60;
        if (m) { var parts = m[1].trim().split(/\s+/); if (parts.length >= 2) { x = parts[0]; var ym = parts[1].match(/(-?\d+(?:\.\d+)?)%/); if (ym) yPct = parseFloat(ym[1]); } }
        items.push({ el: el, x: x, baseY: yPct });
      });
    });
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var rect = it.el.getBoundingClientRect();
        var clamped = Math.max(-1, Math.min(1.5, -rect.top / vh));
        it.el.style.backgroundPosition = it.x + ' ' + (it.baseY + clamped * 14) + '%';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ============================================================
     CART — Shopify AJAX cart drawer
     ============================================================ */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withComma(n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function d2(n) { return withComma((n / 100.0).toFixed(2)); }
    function d0(n) { return withComma(Math.round(n / 100.0).toString()); }
    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value = (token === 'amount_no_decimals' || token === 'amount_no_decimals_with_comma_separator') ? d0(cents) : d2(cents);
    return fmt.replace(placeholderRegex, value);
  }

  var Cart = {
    open: function () { var d = document.getElementById('cart-drawer'); if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } },
    close: function () { var d = document.getElementById('cart-drawer'); if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } },
    refresh: function () {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; });
    },
    add: function (formData) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
        .then(function (r) { return r.json(); }).then(function () { return Cart.refresh(); }).then(function (cart) { Cart.open(); return cart; });
    },
    change: function (key, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
        .then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; });
    },
    render: function (cart) {
      var badge = document.getElementById('cart-badge');
      if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
      var body = document.getElementById('cart-body');
      var foot = document.getElementById('cart-foot');
      if (!body) return;
      if (!cart.items.length) { body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>'; if (foot) foot.hidden = true; return; }
      if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map(function (it) {
        var sub = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' · ') : '';
        var props = '';
        if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && k !== 'Gift note' && it.properties[k]) props += (props ? ' · ' : '') + it.properties[k]; });
        var subline = [sub, props].filter(Boolean).join(' · ');
        var giftNote = it.properties && it.properties['Gift note'];
        var giftHtml = giftNote ? '<span class="cart-line-gift" style="display:block;margin-top:5px;font-family:var(--font-body);font-size:12px;font-style:italic;line-height:1.45;color:rgba(46,30,16,0.62);"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9A6B1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px;margin-right:4px;"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>Gift note: “' + String(giftNote).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '”</span>' : '';
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '';
        return '<div class="cart-line" data-key="' + it.key + '">' +
          '<div class="cart-line-thumb">' + (img ? '<img src="' + img + '" alt="' + it.product_title + '">' : '') + '</div>' +
          '<div class="cart-line-main">' +
            '<span class="cart-line-name">' + it.product_title + '</span>' +
            '<span class="cart-line-sub">' + subline + '</span>' + giftHtml +
            '<div class="cart-line-bottom">' +
              '<span class="cart-qty"><button data-cart-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-cart-inc aria-label="Increase">+</button></span>' +
              '<span class="cart-line-price">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
            '<button class="cart-line-remove" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');
      var subEl = document.getElementById('cart-subtotal');
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
    }
  };
  window.AnjusCart = Cart;

  function setupCart() {
    var toggle = document.getElementById('cart-toggle');
    if (toggle) toggle.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
        var line = e.target.closest('.cart-line');
        if (!line) return;
        var key = line.getAttribute('data-key');
        var qtyEl = line.querySelector('.cart-qty span');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest('[data-cart-remove]')) Cart.change(key, 0);
        else if (e.target.closest('[data-cart-inc]')) Cart.change(key, qty + 1);
        else if (e.target.closest('[data-cart-dec]')) Cart.change(key, qty - 1);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) Cart.close(); });
    }
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      Cart.add(new FormData(form)).then(function () { if (btn) btn.removeAttribute('aria-busy'); }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
    Cart.refresh();
  }

  function init() { setupMenu(); setupCurrency(); setupCookies(); setupPolicyModal(); setupHeaderScroll(); setupHeroParallax(); setupCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();